import React, { Fragment } from "react";

// The site is fully static (Gatsby SSR), so its content is present in the initial
// HTML — there is nothing to "wait" for. The old full-screen preloader overlay
// (position:fixed, z-index:999999, opaque white) hid the hero until a 1s timer
// fired AFTER hydration, which pushed LCP out to ~14s under mobile throttling.
// Rendering the content directly lets the hero paint immediately.
const RootWrapper = ({ element }) => {
  return <Fragment>{element}</Fragment>;
};

export default RootWrapper;
